import * as React from "react";
import { Query } from "react-apollo";
import { Helmet } from "react-helmet";

// GraphQL
import GetUserDetails from "../../GraphQL/Queries/GetUserDetails";

// Presentation/UI
import BackendWrapper from "../../Components/Layouts/BackendWrapper";
import Loader from "../../Components/Loader/DotLoader";

// Local components
import ScheduleCalendar from "./ScheduleCalendar";

// Utils
import { getUserId } from "../../Utils/Helpers";

const userId = getUserId().userId;

class Schedule extends React.Component<{}> {
  render() {
    return (
      <Query query={GetUserDetails} variables={{ id: userId }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Loader />;
          }
          if (error) {
            return <div>There was a problem loading the data</div>;
          }

          const companyId = data.User.company.id;

          return (
            <BackendWrapper>
              <br />
              <br />
              <ScheduleCalendar companyId={companyId} />
              <Helmet title="Schedule" />
            </BackendWrapper>
          );
        }}
      </Query>
    );
  }
}

export default Schedule;



// WEBPACK FOOTER //
// ./src/Containers/Schedule/index.tsx